export default "__VITE_ASSET__Eb8ojU$h__"